import { render, staticRenderFns } from "./GridToolsTransfer.vue?vue&type=template&id=252a499d&"
import script from "./GridToolsTransfer.vue?vue&type=script&lang=js&"
export * from "./GridToolsTransfer.vue?vue&type=script&lang=js&"
import style0 from "./GridToolsTransfer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports